'use client';

import Image from 'next/image';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { A11y, Autoplay, Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { SectionContainer } from '../layout/Container';
import { CardTitle, SectionTitle } from './HomeTypography';

export default function OurPGMs() {
  return (
    <section aria-label="Nossos PGMs">
      <SectionContainer>
        <div className="flex flex-col gap-6 sm:gap-8">
          <SectionTitle title="Nossos PGMs" />
          <div className="flex flex-col gap-2">
            <p className="text-left text-sm leading-relaxed sm:text-base lg:text-lg">
              Um Pequeno Grupo Multiplicador é um grupo de pessoas que se reúne regularmente com o
              objetivo de promover o crescimento espiritual, a comunhão, o evangelismo e o
              discipulado, tendo como missão clara a multiplicação — ou seja, a formação de novos
              grupos a partir do grupo original. Os grupos se reúnem quinzenalmente, normalmente em
              casas ou em salas da igreja.
            </p>
            <p className="text-left text-sm leading-relaxed sm:text-base lg:text-lg">
              Os encontros geralmente incluem leitura e estudo da Bíblia, oração, partilha de
              experiências e apoio mútuo.
            </p>
          </div>
        </div>

        <div className="our-pgs-carousel w-full">
          <style jsx global>{`
            .our-pgs-carousel .swiper-button-next,
            .our-pgs-carousel .swiper-button-prev {
              color: white;
              background: rgba(0, 0, 0, 0.3);
              width: 50px;
              height: 50px;
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
            }

            .our-pgs-carousel .swiper-button-next:after,
            .our-pgs-carousel .swiper-button-prev:after {
              font-size: 20px;
            }

            .our-pgs-carousel .swiper-button-next,
            .our-pgs-carousel .swiper-button-prev {
              top: 90%;
            }
            .our-pgs-carousel .swiper-button-next:hover,
            .our-pgs-carousel .swiper-button-prev:hover {
              background: rgba(0, 0, 0, 0.5);
            }

            .our-pgs-carousel .swiper-pagination {
              left: 4rem;
              right: 4rem;
              width: calc(100% - 8rem);
            }
            .our-pgs-carousel .swiper-pagination-bullet {
              background: black;
              opacity: 0.3;
              padding: 6px;
            }
            .our-pgs-carousel .swiper-pagination-bullet:hover {
              background: black;
              opacity: 0.5;
            }

            .our-pgs-carousel .swiper-pagination-bullet-active {
              background: black;
              opacity: 1;
            }
          `}</style>
          <Swiper
            modules={[Navigation, Pagination, A11y, Autoplay]}
            spaceBetween={30}
            slidesPerView={1}
            navigation
            pagination={{ clickable: true }}
            autoplay={{ delay: 5000 * 1000, disableOnInteraction: false }}
            loop={true}
            breakpoints={{
              640: {
                slidesPerView: 2,
              },
              1024: {
                slidesPerView: 3,
              },
            }}
            className="w-full"
          >
            {redes.map((rede) => (
              <SwiperSlide key={rede.id}>
                <div className="flex flex-col gap-6 pb-20 sm:gap-8 md:p-4 md:pb-20">
                  <div className="relative h-[192px] w-full">
                    <Image
                      src={rede.image}
                      alt={rede.description}
                      height={333}
                      width={192}
                      className="absolute inset-0 top-0 left-0 h-full w-full rounded object-cover"
                    />
                  </div>
                  <CardTitle title={rede.description} />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </SectionContainer>
    </section>
  );
}

const redes: {
  id: number;
  description: string;
  image: string;
}[] = [
  {
    id: 3,
    description: 'Kids',
    image: '/images/pgs/pg-criancas.png',
  },
  {
    id: 4,
    description: 'Turno Extra',
    image: '/images/pgs/pg-turno-extra.png',
  },
  {
    id: 5,
    description: 'A Forja',
    image: '/images/pgs/pg-forja.png',
  },
  {
    id: 6,
    description: 'Unidos em Cristo',
    image: '/images/pgs/pg-unidos.png',
  },
  {
    id: 7,
    description: 'Nasci de Novo',
    image: '/images/pgs/pg-nasci-de-novo.png',
  },
  {
    id: 8,
    description: 'Esperança',
    image: '/images/pgs/pg-esperanca.png',
  },
  {
    id: 9,
    description: 'Só a Graça',
    image: '/images/pgs/pg-so-a-graca.png',
  },
];
